import styled from "styled-components";

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,
    "RadioDiv": styled.div`
        display: flex;
        align-items: center;
        gap: 20px;

        & > button {
            display: flex;
            align-items: center;
            gap: 6px;
            ${({ theme }) => theme.font.small};

            & > img {
                width: 20px;
            }
        }
    `,

    "AreaDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.small_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
                ${({ theme }) => theme.font.small_bold};
            }
        }
    `,

    "ImgUploadDiv": styled.div`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 16px;
    `,
    "ImgElement": styled.div`
        width: fit-content;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: end;
        flex-wrap: wrap;
        gap: 6px;

        & > img {
            width: 160px;
            height: 160px;
            object-fit: cover;
            object-position: center center;
            border-radius: 8px;
            cursor: pointer;
        }

        & > video {
            width: 480px;
        }

        & > button {
            ${({ theme }) => theme.font.extra_small};
            display: flex;
            align-items: center;
            padding-top: 2px;
        }
    `,
}